import React, {useEffect} from "react";
import GenericItem from "../../../common/items/GenericItem";

const VdsSplashPageNewUserItem = ({}) => {
    return (
        <>
            <img alt={`vds-banner`}
                 className={'splash-banner-img'}
                 src={'../images/vds-banner.png'}/>
            <GenericItem title={i18n.payments.productNotes}
                         details={i18n.payments.vds.productNote}/>

            <div style={{ fontSize: '1.2em' }}>
                Videx Data Store Cloud is a Software as a service (SaaS) hosted by Videx.
                <br/><br/>
                It offers hassle-free setup, automatic updates, daily backups, and added convenience.
                <br/><br/>
                With Videx Data Store, you’ll be able to:
                <ul>
                    <li>
                        Store scan data downloaded from TouchProbe Blue, iBR-9000, and CyberBadge
                    </li>
                    <li>
                        Name iButtons, RFID tags, and barcodes for easier identification
                    </li>
                    <li>
                        Filter scan data to create printable and customized reports
                    </li>
                    <li>
                        Export scan data for external programs
                    </li>
                    <li>
                        Import reader, downloader, and scan item IDs to expedite the setup process
                    </li>
                </ul>

                <i>
                    Available with a Videx Data Store Cloud Plus Subscription:
                </i>
                <br/><br/>

                <div className={'row'}>
                    <div className={'col-6'}>
                        <img alt={`vds-mobile`}
                             className={'splash-phone-img'}
                             src={'../images/vds-mobile.png'}/>
                    </div>
                    <div className={'col-6'}>
                        <div className={'plan-sub-title'}>Videx Data Store Mobile</div>
                        <ul>
                            <li>
                                With Videx Data Store Mobile, your mobile device serves as the scanning device for barcodes or RFID tags
                            </li>
                            <li>
                                Scan a secondary item to associate it with a previous scan when more details are required
                            </li>
                        </ul>
                    </div>
                </div>

                <br/>

                <div className={'row'}>
                    <div className={'col-6'}>
                        <img alt={`vdl-mobile`}
                             className={'splash-phone-img'}
                             src={'../images/vdl-mobile.png'}/>
                    </div>
                    <div className={'col-6'}>
                        <div className={'plan-sub-title'}>Videx Data Link Mobile</div>
                        <ul>
                            <li>
                                Videx Data Link Mobile enhances the capabilities of a TouchProbe Blue by enabling remote upload of scan data via Bluetooth, eliminating the need to return to a computer or download station, maximizing efficiency.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default VdsSplashPageNewUserItem;